import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'

import axios from 'axios'
axios.defaults.baseURL = 'http://test.h5api.xiaoxxx.cn';
// console.log(axios)
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.use(VueClipboard)
Vue.prototype.$axios = axios;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
